//系统设置
export default [{
  path: "/menu",
  component: resolve => require(["../pages/system/menu/menu.vue"], resolve),
  name: "menu",
  title: "菜单管理",
  meta: {
    title: "菜单管理"
  }
},
  {
    path: "/authority",
    component: resolve =>
      require(["../pages/system/authority/authority.vue"], resolve),
    name: "authority",
    title: "角色管理",
    meta: {
      title: "角色管理"
    }
  },
  {
    path: "/account",
    component: resolve =>
      require(["../pages/system/account/account.vue"], resolve),
    name: "account",
    title: "系统管理员管理",
    meta: {
      title: "系统管理员管理"
    }
  },
  {
    path: "/adminLog",
    component: resolve =>
      require(["../pages/system/adminLog/adminLog.vue"], resolve),
    name: "adminLog",
    title: "日志管理",
    meta: {
      title: "日志管理"
    }
  },
  {
    path: "/organizatioon",
    component: resolve =>
      require(["../pages/system/organizatioon/organizatioon.vue"], resolve),
    name: "organizatioon",
    title: "部门管理",
    meta: {
      title: "部门管理"
    }
  },
  {
    path: "/employeeRights",
    component: resolve =>
      require(["../pages/system/departmentInfor.vue"], resolve),
    name: "EmployeeRights",
    title: "员工列表",
    meta: {
      title: "员工列表"
    }
  },
  {
    path: "/map",
    component: resolve => require(["../pages/system/mapGarden.vue"], resolve),
    name: "map",
    title: "园区地图",
    meta: {
      title: "园区地图"
    }
  },
  {
    path: "/mapManage",
    component: resolve => require(["../pages/system/mapManage.vue"], resolve),
    name: "mapManage",
    title: "园区地图管理",
    meta: {
      title: "园区地图管理"
    }
  },
  {
    path: "/QAManage",
    component: resolve => require(["../pages/system/QAManage.vue"], resolve),
    name: "QAManage",
    title: "QA管理",
    meta: {
      title: "QA管理"
    }
  },
  {
    path: "/vipcardGrade",
    component: resolve => require(["../pages/system/vipcardGrade/vipcardGrade.vue"], resolve),
    name: "vipcardGrade",
    title: "会员卡等级管理",
    meta: {
      title: "会员卡等级管理"
    }
  },
  {
    path: "/vipcardPlan",
    component: resolve => require(["../pages/system/vipcardPlan/vipcardPlan.vue"], resolve),
    name: "vipcardPlan",
    title: "会员卡计划管理",
    meta: {
      title: "会员卡计划管理"
    }
  },
  {
    path: "/globalConfig",
    component: resolve => require(["../pages/system/globalConfig/globalConfig.vue"], resolve),
    name: "globalConfig",
    title: "全局配置",
    meta: {
      title: "全局配置",
    }
  },
  {
    path: "/settings",
    component: resolve => require(["../pages/system/settings/settings.vue"], resolve),
    name: "settings",
    title: "系统配置",
    meta: {
      title: "系统配置",
    }
  },
  {
    path: '/incomeDepartment',
    component: resolve => require(['../pages/system/incomeDepartment.vue'], resolve),
    name: 'incomeDepartment',
    title: "收益部门管理",
    meta: {
      title: "收益部门管理"
    }
  },
  {
    path: '/siteManage',
    component: resolve => require(['../pages/system/siteManage.vue'], resolve),
    name: 'siteManage',
    title: "通行点配置",
    meta: {
      title: "通行点配置"
    }
  },
  {
    path: '/mapSiteClass',
    component: resolve => require(['../pages/system/mapSiteClass.vue'], resolve),
    name: 'mapSiteClass',
    title: "地图分类",
    meta: {
      title: "地图分类"
    }
  },
  {
    path: '/miniProjectCode',
    component: () =>
      import ('../pages/system/miniProjectCode.vue'),
    name: 'miniProjectCode',
    title: "小程序码",
    meta: {
      title: "小程序码"
    }
  }
];
